import React from 'react';
import UserName from '../../../../elements/UserName/UserName';
import styles from './LeadName.module.scss';
import ParticipantIcon from './participant.svg';

function LeadName(props) {
    const { className='', lead } = props;

    if (!lead) return null;
    if (!lead.participant) return null;

    return (
        <div className={[className, styles.LeadName].join(' ')}>
            <ParticipantIcon />
            <UserName user={lead.participant} />
        </div>
    );
}

export default LeadName;
